module.exports = __webpack_public_path__ + "img/35_34.1d651f1c.png";